export class ComponentModel {
  code: string;
  name: string;
  serialNav: number;
  type: string;
  componentModel: Components[];
  modelType: string;

  static mapFromComponentModel(data: any) {
    if (data) {
      return new ComponentModel({
        code: data.code,
        name: data.name,
        serialNav: data.serialNav,
        type: data.type,
        componentModel: data.componentModel,
        modelType: data.modelType === 'gearbox' ? 'gearbox' : 'direct-drive'
      });
    } else {
      return null;
    }
  }

  constructor(init: Partial<ComponentModel>) {
    Object.assign(this, init);
  }

}

export interface Components {
  id: string;
  name: string;
  alarms: [];
}
